import { render, staticRenderFns } from "./Svg1Section5.vue?vue&type=template&id=1217a5d2&"
import script from "./Svg1Section5.vue?vue&type=script&lang=js&"
export * from "./Svg1Section5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports